import { createFileRoute } from '@tanstack/react-router';
import type { PrintOpts } from '@/api/queries/recipes';
import { RecipePrintScreen } from '@/features/recipes/RecipePrintScreen';

type Search = Partial<Record<keyof PrintOpts, boolean>> & { scale?: number; version?: number };

const FLAGS: Array<keyof PrintOpts> = [
  'family', 'yield', 'servings', 'serving_weight', 'photo', 'instructions',
  'recipe_cost', 'pct', 'stock_cost', 'stock_unit', 'costing', 'labour', 'used_in', 'allergens',
];

const on = (v: unknown) => v === true || v === 1 || v === '1' || v === 'true';

export const Route = createFileRoute('/_app/recipes/$id/print')({
  // Same query string legacy /recipes/<id>/print took: each option is `=1`,
  // plus scale (invalid or <= 0 falls back to 1) and version.
  validateSearch: (s: Record<string, unknown>): Search => {
    const out: Search = {};
    FLAGS.forEach((k) => {
      if (on(s[k])) out[k] = true;
    });
    const sc = Number(s.scale);
    if (Number.isFinite(sc) && sc > 0 && sc !== 1) out.scale = sc;
    const v = Number(s.version);
    if (Number.isInteger(v) && v > 0) out.version = v;
    return out;
  },
  component: PrintRecipe,
});

function PrintRecipe() {
  const { id } = Route.useParams();
  const search = Route.useSearch();
  const opts = Object.fromEntries(FLAGS.map((k) => [k, Boolean(search[k])])) as PrintOpts;
  return <RecipePrintScreen id={Number(id)} opts={opts} scale={search.scale ?? 1} version={search.version ?? null} />;
}
